<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Bullet_Hole-2.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-3"><a id="Contents-A"></a>Contents</p>
</div>
<div class="calibre1">
<p class="ct"></p>
<p class="contents-entry"></p>
<p class="contents-entry"></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/#toc_marker-3">Contents</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole3#toc_marker-4">Dedication</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole4#toc_marker-5">Epigraph</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole5#toc_marker-6">Chapter One</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole6#toc_marker-7">Chapter Two</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole7#toc_marker-8">Chapter Three</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole8#toc_marker-9">Chapter Four</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole9#toc_marker-10">Chapter Five</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole10#toc_marker-11">Chapter Six</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole11#toc_marker-12">Chapter Seven</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole12#toc_marker-13">Chapter Eight</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole13#toc_marker-14">Chapter Nine</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole14#toc_marker-15">More from this Author</a></p>
<p class="contents-entry"><a class="calibre2" href="#/OEBPS/Bullet_Hole15#toc_marker-16">Contact Us</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Bullet_Hole-2.vue?0061620c